<template>
<div class="eventcontainer">
    <b-row style="padding:0;margin:0;background-color:#c0d0d0;">
      <b-col>
      <b-link v-if="prv_room"
        :to="{path: prv_room}"
       >
        <b>&nbsp;Back To Room</b>
      </b-link>
      </b-col>
      <b-col>
      <b-link :to="{name:'eventlist'}"
        class="float-right"
       >
        <b>Event List&nbsp;></b>
      </b-link>
      </b-col>
    </b-row>

    <b-nav tabs align="center">

    <b-nav-item :to="{name:'event', params: {}}"
       exact exact-active-class="active">
       <b>Reception</b>
    </b-nav-item>

    <b-nav-item :to="{name:'sessions', params: {}}"
      v-if="event.sessions && event.sessions.length"
      exact exact-active-class="active">
      <b>Sessions</b>
    </b-nav-item>

    <b-nav-item :to="{name:'speakers', params: {}}"
      v-if="event.speakers && event.speakers.length"
      exact exact-active-class="active">
      <b>Speakers</b>
    </b-nav-item>

    <b-nav-item :to="{name:'booths', params: {}}"
       v-if="event.booths && event.booths.length"
       exact exact-active-class="active">
       <b>Booths</b>
    </b-nav-item>

    <b-nav-item :to="{name:'networking', params: {}}"
        v-if="event.networking && event.networking.length"
        exact exact-active-class="active">
        <b>Networking</b>
    </b-nav-item>

    <b-nav-item :to="{name:'salesrep',params:{}}"
       v-if="show_sreps"
       exact exact-active-class="active">
       <b>Sales Reps</b>
    </b-nav-item>

    <b-nav-item :to="{name:'sponsors', params: {}}"
        v-if="false && event.sponsors && event.sponsors.length"
        exact exact-active-class="active">
        <b>Sponsors</b>
    </b-nav-item>

    </b-nav>
    <div class="subview">
      <router-view :id="this.$route.params.id"></router-view>
    </div>
</div>
</template>

<script>

import utils from "../eventutils";

export default {
  name: "events",
  data() {
    return {
      event: {email_reg:{}},
      acc: null,
      prv_room: null,
      registered: false,
      show_sreps: false,
    }
  },
  methods: {
    toast(k,m) {
        let variant="success";
        let delay = 5000;
        if (k == 'err') {
           variant="danger";
           delay = 20000;
        }
        this.$bvToast.toast([
             this.$createElement('div',{style:'display:none'})
          ], {
          title: m,
          variant: variant,
          autoHideDelay: delay,
          appendToast: true
        })
    },
    show_back: function() {
    },
    do_back: function() {
      window.history.back();
    },
    goto_room: function(roomname) {
       let vue = this;
       let url = "https://"+window.location.host+window.location.pathname;
       url += "#/room/"+roomname;
       if (vue.$parent.mydevice.is_ios_browser) {
          set_post_login_url(url, Date.now());
          present_download("#/room/"+roomname);
       } else {
          window.location.href = url;
       }
    },
    save_and_signin: function() {
       let vue = this;
       let url = window.location.href;
       set_post_login_url(url,Date.now());
       vue.$router.push({name:'login'});
    },
  },
  beforeDestroy() {
     $("body").removeClass("setbackground");
     window.wss_clr_routes(window.vx,"eventview");
  },
  mounted() {
    $("body").addClass("setbackground");
    let vue = this;
    if (vue.$router.vxhist) {
       vue.prv_room = vue.$router.vxhist.room;
    }
    vue.acc = vue.$router.currentRoute.params.acc;

    window.wss_open(vx, {
      acc: vue.acc,
      uid: vx.user? vx.user.id: "not set",
      routes_id: "eventview",
      routes: {
        opened: function(){
           if (!vue.event.id) {
              if (vue.$route.params.id) {
                 window.wss_send(vx, "adm_event_list", {rtag: "eventview",
                    event: { id: vue.$route.params.id}});
              }
           }
        },
        auth_me: function(msg) {
           if (msg.data.error) {
              return;
           }
           vue.authenticated = true;
           window.wss_send(vx, "adm_event_list_attendee", {
             event: {
               id: vue.$route.params.id
             }, att: {
               em: "self",
             }
           });
        },
        adm_event_list: function(msg) {
	    if (msg.rtag != "eventview") return;
	    if ((msg.data.error) ||
		(msg.data.events.length == 0)) {
		console.log(msg.data.error);
		return;
	    }
	    //console.log("Event get",msg.data);
	    if (msg.data.events[0].id == vue.$route.params.id) {
                vue.event = utils.remote_to_local(msg.data.events[0]);
                window.wss_send_cb(vx, "adm_event_get_part", {
                  rtag: "eve",
                  event: {
                    id: vue.event.id,
                    field: "sreps",
                    exists: true,
                 },
               }, function(msg) {
                  if (msg && msg.data && msg.data.obj && msg.data.obj[0]) {
                     vue.show_sreps = true;
                  }
	       });
           }
        },
	adm_event_list_attendee: function(msg) {
            vue.registered = false;
	    if (msg.data.error) {
              return;
            }
            msg.data.attendees.forEach(function(att) {
              att.access.forEach(function(acc) {
                if (acc.groupname) {
		   vue.registered = true;
		}
              });
            });
	},
      }
    });
  }
};
</script>

<style lang="scss" scoped>

.eventcontainer {
   background-color: white;
   max-width:90%;
   margin: 0 5%;
}

@media screen and (max-width:600px) and (orientation:portrait) {
.eventcontainer {
  max-width:100%;
  margin: 0;
}
}

.subview {
   padding-top:20px;
   background-color: #c0d0d0;
}

</style>

